import { useEffect, useState } from "react";
import { Col, Container, Fade, Row } from "react-bootstrap";
import { FaPlusSquare } from "react-icons/fa";
import CustomButton from "shared/components/button/CustomButton";
import { Tabela } from "shared/components/table/Tabela";
import { TableColumn } from "types/table/TableColumn";
import { RenderRowsConfiguracaoDocumento } from "./RenderRowsConfiguracaoDocumento";
import { useGetConfigDocumentoPaginadas } from "hooks/groupsign/useGetConfigDocumentoPaginadas";
import { RequestConfigDocumentoGroupSign } from "types/request/groupSign/RequestConfigDocumentoGroupSign";
import InputSearch from "shared/components/input/InputSearch";
import { EnumTipoDocumentoAssDigital } from "constants/EnumTipoDocumentoAssDigital";
import { useNavigate, useLocation } from "react-router-dom";
import { Rotas } from "constants/EnumRotas";
import { usePermissoesContext } from "context/permissoes/PermissoesContext";
import { TipoPermissao } from "constants/EnumTipoPermissao";

export const TabConfiguracaoDocumento: React.FC = () => {
    const [mostrarConteudo, setMostrarConteudo] = useState<boolean>(false);
    const [paginaAtual, setPaginaAtual] = useState(1);
    const [ordenarPorColuna, setOrdenarPorColuna] = useState<string>("nomeCondominio");
    const [ordenacaoAscOuDesc, setOrdenacaoAscOuDesc] = useState<"ASC" | "DESC">("ASC");
    const [sortString, setSortString] = useState<string>("");
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
    const navigate = useNavigate();
    const location = useLocation();
    const { usuarioPossuiPermissao } = usePermissoesContext();
        const possuiPermissaoIncluirConfiguracaoDocumento = usuarioPossuiPermissao(
          "configuracaoDocumentos",
          TipoPermissao.INCLUIR
      );
    
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    useEffect(() => {
        setPaginaAtual(1);
    }, [debouncedSearchTerm]);

    const params: RequestConfigDocumentoGroupSign = {
        page: paginaAtual - 1,
        size: 10,
        sort: sortString,
        ...(debouncedSearchTerm && {
            nomeCondominio: debouncedSearchTerm,
            tipoDocumento: debouncedSearchTerm as EnumTipoDocumentoAssDigital,
        }),
    };

    const { data: documentosPaginados, isFetching, refetch } = useGetConfigDocumentoPaginadas(params);

    useEffect(() => {
        setMostrarConteudo(true);
    }, []);

    useEffect(() => {
        refetch();
    }, [location]);

    const handleOrdenacao = (idColuna: string) => {
        const novaOrdenacao = ordenarPorColuna === idColuna && ordenacaoAscOuDesc === "ASC" ? "DESC" : "ASC";
        setOrdenarPorColuna(idColuna);
        setOrdenacaoAscOuDesc(novaOrdenacao);
        setSortString(`${idColuna},${novaOrdenacao}`);
    };

    const renderCabecalho = () => {
        return (
            <>
                <Row justify="space-between" >
                    <Col xs={5} >
                        <InputSearch
                            id="buscar-documentos-assdigital-condominio"
                            key="buscar-documentos-assdigital-condominio"
                            label="Buscar:"
                            placeholder="Buscar condomínio ou tipo de documento"
                            onSearchChange={(value) => setSearchTerm(value)}
                        />
                    </Col>
                    <Col xs={7} style={{ textAlign: "right", alignContent: "end" }}>
                    {possuiPermissaoIncluirConfiguracaoDocumento && (
                        <CustomButton
                            id="btn-cancelar-modal-agendar-contato"
                            label="Cadastrar"
                            onClick={() => navigate(Rotas.ASSINATURA_DIGITAL_CONFIGURACAO_DOCUMENTO)}
                            variant="primary"
                            className="ps-4 pe-4"
                            leftIcon={FaPlusSquare}
                        />
                    )}
                    </Col>
                </Row>
            </>
        );
    };

    const createColumns = (): TableColumn[] => {
        return [
            {
                id: "nomeCondominio",
                label: "Condomínio",
                isOrdenavel: false,
                width: "25%",
            },
            {
                id: "tipoDocumento",
                label: "Tipo de documento",
                isOrdenavel: false,
                width: "25%",
            },
            {
                id: "dataHoraConfiguracao",
                label: "Data de configuração",
                isOrdenavel: false,
                width: "25%",
            },
        ];
    };

    const renderTabelaDocumentos = () => {
        return (
            <Row>
                <Col xs={12}>
                    <Tabela
                        id="tabela-configuracao-documentos"
                        colunas={createColumns()}
                        ordernarPorColuna={ordenarPorColuna}
                        ordenacaoAscOuDesc={ordenacaoAscOuDesc}
                        ordenarRegistrosFunction={handleOrdenacao}
                        onChangePageFunction={setPaginaAtual}
                        paginaAtual={paginaAtual}
                        quantidadeDePaginas={documentosPaginados?.totalPages || 0}
                        isLoading={isFetching}
                        quantidadeDeRegistros={documentosPaginados?.totalElements || 0}
                        renderCheckBox={false}
                    >
                        <RenderRowsConfiguracaoDocumento
                            configsDocumentos={documentosPaginados?.content || []}
                        />
                    </Tabela>
                </Col>
            </Row>
        );
    };

    return (
        <Container>
            <Fade in={mostrarConteudo} timeout={1000}>
                <div>
                    {renderCabecalho()}
                    {renderTabelaDocumentos()}
                </div>
            </Fade>
        </Container>
    );
};
